<script setup lang="ts">
import type { QuickActionBadgeProps } from "@/dsComponents/QuickActions/types";

const props = defineProps<QuickActionBadgeProps>();
</script>

<template>
    <div class="quick-action-badge">
        <div class="quick-action-badge__content">
            <span class="quick-action-badge__label typo-xxs-regular">{{ props.label }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
.quick-action-badge {
    display: inline-flex;
    flex-direction: column;
    align-self: flex-start;
    max-width: 100%;
    user-select: none;
    padding: var(--spacing-xs, 4px) var(--spacing-md, 8px) 0 var(--spacing-md, 8px);
    box-sizing: border-box;

    &__content {
        display: inline-flex;
        height: 20px;
        align-items: center;
        padding: 0 var(--spacing-sm, 6px);
        background: var(--bg-weak-100, #eff2f5);
        border-radius: var(--radius-xs, 4px);
    }

    &__label {
        color: var(--text-sub-600, #494e61);
    }
}
</style>
